import React, {
    forwardRef,
    useImperativeHandle,
    useEffect,
    useState
} from 'react'
import { useInterval } from 'ahooks'
// 2023-7-18 答题耗时修改 随堂练习要在继续练习时，展示最新的耗时 newTime上次练习未做完的耗时
// newElapsedTime 答题耗时 s
export default forwardRef(({newElapsedTime = 0, leaveStop = false}, ref ) => {
    const [count, setCount] = useState(newElapsedTime)
    const [interval, setInterval] = useState(1000);
    useEffect(()=>{
        setCount(newElapsedTime)
    },[newElapsedTime])
    const clear = useInterval(() => {
        setCount(count + 1)
    }, interval)
    let h = parseInt((count / 60 / 60) % 24)
    let m = parseInt((count / 60) % 60)
    let s = parseInt(count % 60)

    useEffect(() => {
        return () => {
            clear
        }
    })

    useEffect(()=>{
        const handleVisibilityChange = ()=>{
            if (document.hidden && leaveStop) {
                setInterval(undefined)
            } else {
                setInterval(1000)
            }
        }
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            document.removeEventListener('visibilitychange', ()=>{});
        }
    },[])

    useImperativeHandle(ref, () => ({
        countNum: () => count
    }))

    return (
        <span>{`${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}:${
            s < 10 ? '0' + s : s
        }`}</span>
    )
})
